import { Box, Container, Flex, Grid, HStack, Text, VStack } from "@chakra-ui/layout";
import { Image, useMediaQuery } from '@chakra-ui/react';
import { RTag } from "@components/Texts/Tag/Tag";
import { WidgetTitle } from "@components/Texts/WidgetTitle/WidgetTitle";
import { Tile, TILE_MODES } from "@components/Tiles/Tile";
import { HorizontalWidget } from "@components/Widgets/HorizontalWidget/HorizontalWidget";
import { TwoRowsWidget } from "@components/Widgets/TwoRowsWidget/TwoRowsWidget";
import { generateBlogCategoryUrl, generateBlogTagUrl } from "@core/paths";
import { Link } from "@reach/router";
import { chunk, shuffle } from "lodash";
import moment from "moment";
import * as React from "react";
import { useMemo } from "react";
import { Layout } from "../../components";
import AskQuestion from "../SensitiveQuestions/AskQuestion";

moment.locale("pl");

// enum SECTION_TYPES {
//   COLUMNS_2X_ROWS_2X = "COLUMNS_2X_ROWS_2X",
//   COLUMNS_1X_ROWS_1X = "COLUMNS_1X_ROWS_1X",
//   COLUMNS_1X_ROWS_1X_BLUE = "COLUMNS_1X_ROWS_1X_BLUE",
// }

// enum WIDGET_TYPES {
//   COLUMNS_2X_ROWS_2X = "COLUMNS_2X_ROWS_2X",
//   COLUMNS_4X_ROWS_1X = "COLUMNS_4X_ROWS_1X",
//   COLUMNS_1X_ROWS_1X = "COLUMNS_1X_ROWS_1X",
// }

// const widgetOptions = [
//   {
//     type: WIDGET_TYPES.COLUMNS_2X_ROWS_2X,
//     gridTemplateColumns: "repeat(2, 1fr)",
//     totalPosts: 4,
//   },
//   {
//     type: WIDGET_TYPES.COLUMNS_4X_ROWS_1X,
//     gridTemplateColumns: "repeat(4, 1fr)",
//     totalPosts: 4,
//   },
//   {
//     type: WIDGET_TYPES.COLUMNS_1X_ROWS_1X,
//     gridTemplateColumns: "1fr",
//     totalPosts: 1,
//   },
// ];

// const getWidgetOptionByType = (type: WIDGET_TYPES) =>
//   widgetOptions.find(({ type: widgetType }) => type === widgetType);

// const sectionOptions = [
//   {
//     type: SECTION_TYPES.COLUMNS_2X_ROWS_2X,
//     totalWidgets: 2,
//     gridTemplateColumns: "repeat(2, 1fr)",
//     widgetOptions: [
//       WIDGET_TYPES.COLUMNS_1X_ROWS_1X,
//       WIDGET_TYPES.COLUMNS_2X_ROWS_2X,
//     ].map(type => getWidgetOptionByType(type)),
//   },
//   {
//     type: SECTION_TYPES.COLUMNS_1X_ROWS_1X,
//     totalWidgets: 1,
//     gridTemplateColumns: "1fr",
//     widgetOptions: [WIDGET_TYPES.COLUMNS_4X_ROWS_1X].map(type =>
//       getWidgetOptionByType(type)
//     ),
//   },
//   {
//     type: SECTION_TYPES.COLUMNS_1X_ROWS_1X_BLUE,
//     totalWidgets: 1,
//     background: "blue",
//     gridTemplateColumns: "1fr",
//     widgetOptions: [WIDGET_TYPES.COLUMNS_4X_ROWS_1X].map(type =>
//       getWidgetOptionByType(type)
//     ),
//   },
// ];

export const HomePage: React.FC<any> = ({
  homePage,
  categories,
  childCategories,
  posts,
  postsByCategory,
  featuredQuestion,
  sensitiveQuestions,
  tags,
}) => {
  const [sections, setSections] = React.useState([]);
  // return <>...</>;
  // console.warn(categories);
  // const [topFeaturedPost] = featuredPosts;
  // const restCategories = categories.filter(
  //   ({ id }) =>
  //     id !== firstCategory.id &&
  //     id !== secondCategory.id &&
  //     postsByCategory[id].length > 1
  // );

  // const generateSections = (
  //   categories: any[],
  //   sections = [],
  //   prevSectionType?: SECTION_TYPES
  // ) => {
  //   const allowedSectionOptions = sectionOptions.filter(
  //     ({ type, totalWidgets }) => {
  //       const isMinimumCategoriesLengthMet = totalWidgets <= categories.length;
  //       const isNotSameSectionTypeAsPreviousOne = prevSectionType !== type;
  //       return (
  //         isMinimumCategoriesLengthMet && isNotSameSectionTypeAsPreviousOne
  //       );
  //     }
  //   );
  //   const sectionOption = sample(allowedSectionOptions);
  //   const sectionCategories = categories.slice(0, sectionOption.totalWidgets);
  //   const restCategories = categories.slice(sectionOption.totalWidgets);

  //   const section = {
  //     ...sectionOption,
  //     widgets: sectionCategories.map(category => {
  //       const widgetOption = sample(
  //         sectionOption.widgetOptions.filter(
  //           ({ totalPosts }) => totalPosts <= category.posts.length
  //         )
  //       );
  //       return {
  //         config: widgetOption,
  //         category,
  //         posts: category.posts,
  //       };
  //     }),
  //   };

  //   return restCategories.length === 0
  //     ? [...sections, section]
  //     : [
  //         section,
  //         ...generateSections(restCategories, sections, sectionOption.type),
  //       ];
  // };

  // React.useEffect(() => {
  //   const sections = generateSections(
  //     shuffle(categories).map(category => ({ ...category, posts: [] }))
  //   );
  //   setSections(sections);
  // }, []);

  const [isDesktop] = useMediaQuery("(min-width: 992px)");

  const firstCategory = categories.find(({ name }) => name === 'MGnews');
  const secondCategory = categories.find(({ name }) => name === 'TRUDNE PYTANIA'); // Trudne pytania

  const chunkCategories = useMemo(() => chunk(childCategories.filter(({ parent }) => parent?.node?.name !== 'TRUDNE PYTANIA'), 2), []);

  const { leftBarPosts, leftBarCategory, rightBarPosts, rightBarCategory, newsOfTheDay } = homePage.homePageConfig;

  return (
    <Layout
      metaTitle="Blog"
      metaType="object"
      categories={categories}
      tags={tags}
    >
      <Container mb={{ base: '100px', sm: 0 }} maxW="1130px" px="15px" mt={{ base: 0, md: "20px" }}>
        <Grid templateColumns={{ base: "100%", md: "25% 40% 25%", lg: "250px 515px 250px" }} gap={{ base: 0, md: "25px" }} mb={{ base: '17px', md: "60px" }}>
          <Box order={{ base: 1, md: 2 }} border={{ base: 'none', sm: "1px solid #E7F2FF" }} px={{ base: 0, sm: "25px" }} py={{ base: 0, sm: '20px' }}>
            <Tile mode={TILE_MODES.PRIMARY} article={newsOfTheDay} />
          </Box>

          <Box order={{ base: 2, md: 0 }}>
            <WidgetTitle d={{ base: 'none', sm: 'block' }} mb="20px">{leftBarCategory.name}</WidgetTitle>
            <VStack d={{ base: 'none', sm: 'block' }} spacing="30px" alignItems="flex-start">
              {leftBarPosts.slice(0, 2).map((post, i) => (
                <Tile key={post.id} mode={i === 0 ? TILE_MODES.DESCRIPTIVE_WITH_THUMBNAIL : TILE_MODES.SHORT_WITHOUT_THUMBNAIL_AND_MARGIN} article={post} />
              ))}
            </VStack>
            <VStack d={{ base: 'flex', sm: 'none' }} gridGap="22px" alignItems="flex-start">
              {leftBarPosts.slice(0, 3).map((post, i) => (
                <Tile key={post.id} mode={TILE_MODES.SHORT_MOBILE_THUMBNAIL_RIGHT} article={post} />
              ))}
            </VStack>
          </Box>

          <Box d={{ base: 'none', md: 'block' }} order={{ base: 3, sm: 3 }}>
            <WidgetTitle mb="20px">{rightBarCategory.name}</WidgetTitle>
            <VStack alignItems="flex-start">
              {rightBarPosts.slice(0, 2).map((post, i) => (
                <Tile key={post.id} mode={i === 0 ? TILE_MODES.DESCRIPTIVE_WITH_THUMBNAIL : TILE_MODES.SHORT_WITHOUT_THUMBNAIL_AND_MARGIN} article={post} />
              ))}
            </VStack>
          </Box>
        </Grid>

        <HorizontalWidget isDate={true} backgroundColor="transparent" category={firstCategory} posts={firstCategory.posts} mode={TILE_MODES.DESCRIPTIVE_WITH_THUMBNAIL} />

        <VStack gridGap={{ base: 0, sm: '30px' }} mb={{ base: '17px', sm: "60px" }}>
          <HStack justifyContent="space-between" pr={{ md: "14px", lg: 0 }} w="100%">
            <WidgetTitle p={{ base: '17px 14px', sm: '0' }} borderLeft="0" color="#E8278E" d="flex" alignItems="center">
              <Image maxH={{ base: '38px', sm: "50px" }} src={secondCategory.categoryConfig?.logo?.sourceUrl} alt="" mr="20px" />
              <Text d={{ base: 'none', sm: 'block' }} color="#E50178">TRUDNE PYTANIA</Text>
              <Text cursor="pointer" d={{ base: 'block', sm: 'none' }} as={Link} to={generateBlogCategoryUrl(secondCategory.slug)} color="#E50178">TRUDNE PYTANIA</Text>
            </WidgetTitle>
            <WidgetTitle d={{ base: ' none', md: 'block' }} as={Link} to={generateBlogCategoryUrl(secondCategory.slug)} mb="23px" borderLeftColor="#E8278E" color="#E8278E">Przejdź do kategorii</WidgetTitle>
          </HStack>

          <VStack alignItems="flex-start" gridGap={{ base: '0', sm: '32px' }} w="100%">
            <Grid templateColumns={{ base: "100%", sm: "repeat(4, 1fr)" }} gap="32px">
              {secondCategory.posts.slice(0, 4).map((post, i) => (
                <Tile key={post.id} mode={TILE_MODES.SHORT_WITH_THUMBNAIL} article={post} />
              ))}
            </Grid>
            <Box d={{ base: 'block', md: 'none' }}>
              <AskQuestion pt="20px" />
            </Box>
            <Flex d={{ base: 'none', md: 'flex' }} mt={{ base: "24px !important", md: 0 }} bg="#EAF4FF" w="100%" pl="41px" pr="21px" pt="21px" justifyContent="space-between" direction={{ base: 'column', sm: "row" }}>
              <Box pb="30px">
                <Text fontSize="20px" fontWeight="900" fontFamily="MuseoModerno">Męczy Cię bardzo trudny temat i chcesz się nim z nami podzielić?</Text>
                <Text fontSize="13px" color="#817653">Napisz do nas anonimowo, postaramy się odpowiedzieć. Zachowasz w 100% anonimowość.</Text>
              </Box>
              <AskQuestion />
            </Flex>

          </VStack>
        </VStack>


        {shuffle(chunkCategories).map(([first, second], i) => i % 2 === 0 ? (
          <React.Fragment key={second ? second.id : first.id}>
            {
              second?.posts && (
                <HorizontalWidget isDate={false} backgroundColor='#EAF4FF' category={second} posts={second.posts} mode={TILE_MODES.DESCRIPTIVE_WITHOUT_THUMBNAIL} />
              )
            }
            {
              first?.posts && (
                <HorizontalWidget isDate={false} backgroundColor='transparent' category={first} posts={first.posts} mode={TILE_MODES.SHORT_WITH_THUMBNAIL} />
              )
            }
          </React.Fragment>
        ) :
          first && second
            ? <TwoRowsWidget isDate={false} key={first.id} backgroundColor="#EAF4FF" firstCategory={first} secondCategory={second} />
            : <HorizontalWidget isDate={false} key={first.id} backgroundColor='#EAF4FF' category={second ? second : first} posts={second ? second.posts : first.posts} mode={TILE_MODES.DESCRIPTIVE_WITHOUT_THUMBNAIL} />

        )}

        <VStack mb={{ base: '20px', sm: '0' }} alignItems="flex-start" spacing="26px">
          <WidgetTitle>Częste tagi</WidgetTitle>
          <Flex wrap="wrap">{tags.map(tag => (<RTag key={`tag_${tag.id}_${tag.slug}`} as={Link} to={generateBlogTagUrl(tag.slug)}>{tag.name}</RTag>))}</Flex>
        </VStack>
      </Container>
      {/* <Container>
        {sections.map(({ gridTemplateColumns, widgets }) => (
          <Section gridTemplateColumns={gridTemplateColumns}>
            {widgets.map(({ posts, title, gridTemplateColumns }) => (
              <Widget gridTemplateColumns={gridTemplateColumns}></Widget>
            ))}
          </Section>
        ))}
      </Container> */}
    </Layout>
  );
};

export default HomePage;